var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.32427 10.555C4.32427 9.86935 4.43814 9.21203 4.64139 8.5955L1.08395 5.87891C0.390626 7.28662 0 8.87282 0 10.555C0 12.2357 0.390145 13.8209 1.08251 15.2277L4.63802 12.5058C4.4367 11.8922 4.32427 11.2372 4.32427 10.555Z",
    fill: "#FBBC05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5646 4.31814C12.0541 4.31814 13.3994 4.84591 14.4565 5.70954L17.5315 2.63886C15.6577 1.00757 13.2553 0 10.5646 0C6.38737 0 2.79726 2.38889 1.07812 5.87939L4.63556 8.59597C5.45525 6.10777 7.7918 4.31814 10.5646 4.31814Z",
    fill: "#EB4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5646 16.7935C7.7918 16.7935 5.45525 15.0038 4.63556 12.5156L1.07812 15.2317C2.79726 18.7227 6.38737 21.1116 10.5646 21.1116C13.1428 21.1116 15.6043 20.1962 17.4517 18.4809L14.075 15.8703C13.1222 16.4706 11.9224 16.7935 10.5646 16.7935Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6603 10.5559C20.6603 9.93216 20.5642 9.26045 20.42 8.63672H10.5703V12.715H16.2399C15.9564 14.1054 15.1848 15.1744 14.0807 15.8701L17.4574 18.4806C19.3981 16.6795 20.6603 13.9965 20.6603 10.5559Z",
    fill: "#4285F4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/googleIcon.7b5f9bce5db70bb3aeb7078e46d0bc0b.svg";
export { ForwardRef as ReactComponent };